import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  IDCARD_BACK_SIDE: 0,
  IDCARD_FRONT_SIDE: 1,
}, km({
  IDCARD_SAVEIDENTITY_SUCCESS: null,
  IDCARD_SAVEIDENTITY_ERROR: null,
  IDCARD_GETIDENTITYINFO_SUCCESS: null,
  IDCARD_GETIDENTITYINFO_ERROR: null,
  IDCARD_CHECKIDENTITY_SUCCESS: null,
    IDCARD_CHECKIDENTITY_ERROR: null,
    /*yeoman-template-point-1*/
}))
